<template lang="pug">
  .report

    PCheckbox(v-model="reportOptions.multipleTimelogs" @change="desativarSubitens" label="Mostrar todos os pontos do dia")
    .option(v-if="reportOptions.multipleTimelogs")
      PCheckbox(v-model="reportOptions.repeatEmpInfo" :label="`Repetir informações dos ${$wp('employee')} em linhas duplicadas`")
      PCheckbox(v-model="reportOptions.mostrarEnderecoDoPonto" :label="`Mostrar endereço do ponto`")

    PCheckbox(v-model="reportOptions.compensateWho" label="Não considerar horas que estão no banco de horas")
    PCheckbox(v-model="reportOptions.fired" @change="changeCommon" :label="`Considerar ${$wp('employee')} demitidos`")
    PCheckbox(v-model="reportOptions.mostrarCodigoDoDispositivo" label="Mostrar código dos dispositivos")
    PCheckbox(v-model="reportOptions.mostrarCodigoDoLocalTrabalho" label="Mostrar código dos locais de trabalho")

    .button
      PButton(color="success" size="md" @click="generate('excel')" :loading="loading" :disabled="!valid") gerar excel

</template>

<script>
import moment from 'moment'
import { setAmplitudeEvent } from 'src/amplitudeUtils'
export default {
  props: {
    reportInfo: {type: Object},
    valid: {type: Boolean}
  },
  data () {
    return {
      loading: false,
      reportOptions: {
        multipleTimelogs: false,
        compensateWho: false,
        fired: false,
        repeatEmpInfo: false,
        mostrarEnderecoDoPonto: false,
        mostrarCodigoDoDispositivo: false,
        mostrarCodigoDoLocalTrabalho: false
      }
    }
  },
  computed: {},
  methods: {
    async generate (typeReport) {
      this.loading = true

      let result

      const params = {
        entity: this.reportInfo.entity,
        entityContent: this.reportInfo.entityContent.map(i => i.id),
        ...this.reportOptions,
        startDate: moment(this.reportInfo.periodData.startDate).format('MM-DD-YY'),
        endDate: moment(this.reportInfo.periodData.endDate).format('MM-DD-YY')
      }

      try {
        result = await this.$API.R09.save(params)
        setAmplitudeEvent('gera relatorio R09', {})
      } catch (e) {
        result = e
      }
      this.$emit('handleReport', result)

      this.loading = false
    },

    changeCommon () {
      if (this.reportOptions.fired) {
        this.$emit('changeCommon', 'employee', 'employees')
      } else {
        this.$emit('changeCommon', 'employee', 'employees/onlyNotFired')
      }
    },
    desativarSubitens () {
      this.reportOptions.mostrarEnderecoDoPonto = false
      this.reportOptions.repeatEmpInfo = false
    }
  }
}
</script>

<style scoped lang="scss">
.report {
  display: grid;

  .option {
      display: flex;
      margin-left: 30px;
      flex-direction: column;
  }

  .button {
    justify-self: end;

    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 10px;
  }
}
</style>
